<template>
  <div class="container my-5">
    <button @click="goBack" class="btn btn-secondary mb-3">
      <font-awesome-icon icon="arrow-left" /> Zurück
    </button>

    <!-- Versteckter PDF-Inhalt -->
    <div ref="pdfContent" class="pdf-template avoid-page-break" style="display: none;">
      <div class="header">
        <img src="/logo.png" alt="Logo" width="100" style="float:left; margin-right:10px;" />
        <div class="address-block">
          <p>PROSECO</p>
          <p>Bernstrasse 131</p>
          <p>3052 Zollikofen</p>
        </div>
      </div>
      <h2 class="text-center my-4">Auszahlungsbeleg</h2>
      <p>Kunde: {{ customerName }}</p>
      <p>Kundennummer: {{ customerId }}</p>
      <table class="table avoid-page-break">
        <thead>
          <tr>
            <th>Artikelnummer</th>
            <th>Artikel</th>
            <th>Angenommen am</th>
            <th>Verkauft am</th>
            <th>Verkaufspreis (CHF)</th>
            <th>Kommission (CHF)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="a in articles" :key="a.ArticleId">
            <td>{{ a.ArticleId }}</td>
            <td>{{ a.Name }}<span v-if="a.Color">, {{ a.Color }}</span></td>
            <td>{{ formatDate(a.ReceivedDate) }}</td>
            <td>{{ formatDate(a.SaleDate) }}</td>
            <td>{{ $formatPrice(a.PriceDiscountLevel3 ?? a.PriceDiscountLevel2 ?? a.PriceDiscountLevel1 ?? a.SalePrice) }}</td>
            <td>{{ $formatPrice(a.CommissionAmount) }}</td>
          </tr>
        </tbody>
      </table>
      <div class="footer avoid-page-break my-3">
        <p><strong>Total Kommission: {{ $formatPrice(totalAmount) }}</strong></p>
      </div>
      <div class="signature-section avoid-page-break mt-5">
        <p><strong>Hiermit bestätige ich den Erhalt des ausgezahlten Betrages in Höhe von {{ $formatPrice(totalAmount)
            }}.</strong></p>
        <p>Datum: ________________________________</p>
        <p>Unterschrift: ________________________________</p>
        <p class="mt-3">Mit meiner Unterschrift erkläre ich, dass alle Ansprüche hinsichtlich der oben aufgeführten
          Artikel beglichen sind.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/services/axios'; // zentrale axios-Instanz
import html2pdf from 'html2pdf.js';

export default {
  name: 'PayoutDownload',
  props: ['id'],
  data() {
    return {
      customerName: '',
      customerId: null,
      articles: [],
      totalAmount: 0,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      const dd = ('0' + d.getDate()).slice(-2);
      const mm = ('0' + (d.getMonth() + 1)).slice(-2);
      const yyyy = d.getFullYear();
      return `${dd}.${mm}.${yyyy}`;
    },
    async fetchPayout() {
      try {
        const res = await axios.get(`/payouts/${this.id}`);
        const p = res.data;
        this.customerName = `${p.Customer.FirstName} ${p.Customer.LastName}`;
        this.customerId = p.CustomerId;
        this.articles = p.Articles;
        this.totalAmount = p.TotalAmount;

        this.$nextTick(this.generatePdf);
      } catch (err) {
        console.error(err);
      }
    },
    generatePdf() {
      const elem = this.$refs.pdfContent;
      elem.style.display = 'block';
      const opts = {
        margin: 0.5,
        filename: `Auszahlungsbeleg_${this.customerName}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'A4', orientation: 'portrait' },
        pagebreak: { mode: 'avoid-all' },
      };
      const worker = html2pdf().set(opts).from(elem);
      worker.toPdf().get('pdf').then(pdf => {
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          const w = pdf.internal.pageSize.getWidth();
          const h = pdf.internal.pageSize.getHeight();
          const txt = `Seite ${i} von ${totalPages}`;
          const txtW = pdf.getTextWidth(txt);
          pdf.text(txt, (w - txtW) / 2, h - 0.3);
        }
      })
        .then(() => worker.save())
        .then(() => { elem.style.display = 'none'; });
    }
  },
  mounted() {
    this.fetchPayout();
  },
};
</script>


<style>
/* Kopiere hier die gleichen Styles wie in Deiner Auszahlung.vue,
     insbesondere die Klassen .avoid-page-break, .header, .address-block etc. */
</style>